var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 859,
    height: 435,
    viewBox: "0 0 859 435",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.937 115L236.577 128.995L178.791 272.02C178.377 273.044 177.212 273.539 176.187 273.125L143.402 259.879L201.937 115Z",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.3602,
    height: 82.4366,
    transform: "translate(209 127.598) rotate(-23)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 49,
    transform: "translate(201 113)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.948 202.647L276.11 187.989L257.27 237.067L240.948 202.647Z",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 11,
    transform: "translate(145 261)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.526,
    y1: 273.842,
    x2: 178.526,
    y2: 270.842,
    stroke: "#6A90B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 272.5,
    x2: 178,
    y2: 272.5,
    stroke: "#6A90B4",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.552 254.832L149.016 275.148L137.276 273.707L145.552 254.832Z",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149,
    y1: 274.5,
    x2: 140,
    y2: 274.5,
    stroke: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 275.5,
    x2: 141,
    y2: 275.5,
    stroke: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.4044,
    height: 38.5451,
    transform: "translate(218.439 198) rotate(22)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.7521,
    height: 80.8795,
    transform: "translate(205.43 234.543) rotate(-24)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237,
    y1: 308.5,
    x2: 240,
    y2: 308.5,
    stroke: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.6376,
    height: 41,
    transform: "translate(214.361 208.337) rotate(-22)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.8349,
    height: 160.536,
    transform: "translate(301.989 148) rotate(22)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.8349,
    height: 161.06,
    transform: "translate(312.578 147.705) rotate(21)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 12,
    transform: "translate(303 148)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 9,
    transform: "translate(238 299)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7.55931,
    transform: "translate(334.524 148.293) rotate(21)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336,
    y1: 149,
    x2: 341,
    y2: 149,
    stroke: "#6A90B4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340.526,
    y1: 150.842,
    x2: 341.526,
    y2: 147.842,
    stroke: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    transform: "translate(338 150)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.936,
    y1: 184.013,
    x2: 232.971,
    y2: 203.567,
    stroke: "#6A90B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.464,
    y1: 184.186,
    x2: 216.464,
    y2: 204.186,
    stroke: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 8.08551,
    transform: "translate(221.159 192.001) rotate(23)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.9805,
    height: 3.17097,
    transform: "translate(227.239 199) rotate(23)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.62043,
    height: 0.793292,
    transform: "translate(227.31 198.189) rotate(23)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.10258,
    height: 1.19266,
    transform: "translate(228.239 197.395) rotate(23)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.88548,
    height: 1.78487,
    transform: "translate(228.432 196.36) rotate(14)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 9,
    transform: "translate(223 187)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5,
    transform: "translate(226 190)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 3.2,
    transform: "translate(227 192)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    transform: "translate(228 194)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 4,
    transform: "translate(222 189)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(221 191)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3,
    transform: "translate(223 185)",
    fill: "#6A90B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.447,
    y1: 184.134,
    x2: 221.584,
    y2: 188.775,
    stroke: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 113.5,
    x2: 243,
    y2: 113.5,
    stroke: "#6A90B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.337,
    y1: 118.752,
    x2: 201.803,
    y2: 112.513,
    stroke: "#F5F5F5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 275.262,
    y1: 186.809,
    x2: 276.469,
    y2: 189.732,
    stroke: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302,
    y1: 148.5,
    x2: 303,
    y2: 148.5,
    stroke: "#6A90B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 147.5,
    x2: 314,
    y2: 147.5,
    stroke: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 147.5,
    x2: 342,
    y2: 147.5,
    stroke: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281,
    y1: 307.5,
    x2: 279,
    y2: 307.5,
    stroke: "#6A90B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.648 309L333.208 284.04H331.192V309H312.376V241.32H342.04C347.48 241.32 352.088 242.28 355.864 244.2C359.64 246.056 362.488 248.648 364.408 251.976C366.328 255.24 367.288 258.92 367.288 263.016C367.288 267.624 366.008 271.688 363.448 275.208C360.952 278.664 357.272 281.128 352.408 282.6L367.672 309H346.648ZM331.192 271.176H340.504C343.064 271.176 344.984 270.568 346.264 269.352C347.544 268.136 348.184 266.376 348.184 264.072C348.184 261.896 347.512 260.2 346.168 258.984C344.888 257.704 343 257.064 340.504 257.064H331.192V271.176ZM410.117 309L396.677 284.04H394.661V309H375.845V241.32H405.509C410.949 241.32 415.557 242.28 419.333 244.2C423.109 246.056 425.957 248.648 427.877 251.976C429.797 255.24 430.757 258.92 430.757 263.016C430.757 267.624 429.477 271.688 426.917 275.208C424.421 278.664 420.741 281.128 415.877 282.6L431.141 309H410.117ZM394.661 271.176H403.973C406.533 271.176 408.453 270.568 409.733 269.352C411.013 268.136 411.653 266.376 411.653 264.072C411.653 261.896 410.981 260.2 409.637 258.984C408.357 257.704 406.469 257.064 403.973 257.064H394.661V271.176ZM458.13 256.392V267.432H479.73V281.736H458.13V293.928H482.61V309H439.314V241.32H482.61V256.392H458.13ZM557.763 241.32L534.435 309H510.339L486.915 241.32H507.075L522.435 290.184L537.699 241.32H557.763ZM596.074 309.672C589.738 309.672 583.914 308.2 578.602 305.256C573.29 302.248 569.066 298.12 565.93 292.872C562.858 287.56 561.322 281.576 561.322 274.92C561.322 268.264 562.858 262.312 565.93 257.064C569.066 251.752 573.29 247.624 578.602 244.68C583.914 241.736 589.738 240.264 596.074 240.264C602.474 240.264 608.298 241.736 613.546 244.68C618.858 247.624 623.05 251.752 626.122 257.064C629.194 262.312 630.73 268.264 630.73 274.92C630.73 281.576 629.194 287.56 626.122 292.872C623.05 298.12 618.858 302.248 613.546 305.256C608.234 308.2 602.41 309.672 596.074 309.672ZM596.074 292.2C600.874 292.2 604.65 290.632 607.402 287.496C610.218 284.36 611.626 280.168 611.626 274.92C611.626 269.544 610.218 265.32 607.402 262.248C604.65 259.112 600.874 257.544 596.074 257.544C591.21 257.544 587.402 259.112 584.65 262.248C581.898 265.32 580.522 269.544 580.522 274.92C580.522 280.232 581.898 284.456 584.65 287.592C587.402 290.664 591.21 292.2 596.074 292.2Z",
    fill: "#6A90B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 747,
    height: 275,
    fill: "white",
    transform: "translate(54 70)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d736b3c7793f3e04742ecd72783b6b26.svg";
export { ForwardRef as ReactComponent };